namespace Matrix.Dashboards {
    export enum AggregateType {
        Count = 0,
        Sum = 1,
        Avg = 2,
        Min = 3,
        Max = 4
    }
    Serenity.Decorators.registerEnumType(AggregateType, 'Matrix.Dashboards.AggregateType');
}
